import {
  Compass,
  FileText,
  FolderCheck,
  Globe2,
  ShieldCheck
} from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { introFeatures } from "../../data/homeData";

const iconMap = {
  globe: Globe2,
  target: Compass,
  file: FileText,
  folder: FolderCheck,
  shield: ShieldCheck
};

function IntroSection() {
  return (
    <MotionSection id="what-we-do" className="relative py-20 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="What We Do"
          title="Expert Guidance Across Every Critical Stage"
          description="NextEra Abroad supports students and families with destination planning, admissions strategy, application support, documentation review, and practical visa guidance."
        />

        <div className="mt-12 grid gap-6 lg:grid-cols-[1fr_2fr]">
          <article className="group card-dark relative overflow-hidden flex flex-col justify-end p-8 min-h-[300px]">
            <div className="absolute top-0 right-0 -mr-8 -mt-8 h-40 w-40 rounded-full bg-royal-blue/20 blur-3xl pointer-events-none" />
            
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white/10 text-warm-gold border border-white/20 backdrop-blur-md mb-auto shadow-lg">
              {(() => {
                const FirstIcon = iconMap[introFeatures[0].icon] || Globe2;
                return <FirstIcon className="h-6 w-6" aria-hidden="true" />;
              })()}
            </div>
            
            <div className="relative z-10 mt-12">
              <h3 className="text-xl font-bold leading-tight text-soft-white sm:text-2xl md:text-3xl">
                {introFeatures[0].title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-sky-glow/80">
                {introFeatures[0].description}
              </p>
            </div>
          </article>

          <div className="grid gap-4 sm:grid-cols-2">
            {introFeatures.slice(1).map((feature) => {
              const Icon = iconMap[feature.icon];

              return (
                <article
                  key={feature.title}
                  className="group card-elevated rounded-2xl p-6"
                >
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue transition-colors group-hover:bg-royal-blue group-hover:text-soft-white">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <h3 className="mt-5 text-lg leading-tight md:text-xl">{feature.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-text/75">{feature.description}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default IntroSection;
